import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import {
  closeModalByNameAction,
  PlainModals,
} from 'store/modules/modals/modals.reducer';
import {
  StyledTableBodyCell,
  StyledTableHeaderCell,
} from 'components/table/styles';
import {
  useGetModalMetaData,
  useIsPlainModalOpenSelector,
} from 'store/modules/modals/modals.selector';
import { paths } from 'constants/routes';
import { ModalContainer } from 'components/modals/modal-container/modal-container';
import {
  setActiveFindingsTab,
  setActiveTab,
} from 'store/modules/assets/assets.reducer';

export const PackageRepositoriesModal = () => {
  const dispatch = useDispatch();
  const metaData = useGetModalMetaData();
  const navigate = useNavigate();

  //@ts-ignore
  const repositories: { name: string; repo_slug: string }[] =
    metaData?.repositories;

  const isModalOpen = useIsPlainModalOpenSelector(
    PlainModals.PACKAGE_REPOSITORIES_MODAL,
  );

  const handleCloseModal = () => {
    dispatch(closeModalByNameAction(PlainModals.PACKAGE_REPOSITORIES_MODAL));
  };

  const openAssetsDetailsPage = (id: string) => {
    dispatch(closeModalByNameAction(PlainModals.PACKAGE_REPOSITORIES_MODAL));
    dispatch(setActiveTab(0));
    dispatch(setActiveFindingsTab(0));
    navigate(`${paths.assetsDetails}?id=${id}`);
  };

  return (
    <ModalContainer
      title="Repositories"
      isOpenModal={isModalOpen}
      handleCloseModal={handleCloseModal}
      modalWidth="700px"
      modalHeight="400px"
    >
      <TableContainer sx={{ marginTop: '25px', maxHeight: '750px' }}>
        <Table
          stickyHeader
          sx={{ minWidth: '550px', backgroundColor: 'transparent' }}
          size="small"
        >
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell align="left">
                Repo Name
              </StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {repositories?.map((item, index) => (
              <TableRow key={index}>
                <StyledTableBodyCell
                  sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => openAssetsDetailsPage(item.repo_slug)}
                  align="left"
                >
                  {item.name}
                </StyledTableBodyCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ModalContainer>
  );
};
